import { OverallSyllabusChecklistSchema } from "@tsTypes/sylllabus-checklist-schema";

/**
 * Ensures that the syllabus meta state contains blank subject, topic, and subtopic meta if missing.
 * @param {OverallSyllabusChecklistSchema} state - The syllabus meta state object
 * @param {string} subjectDocumentId - The subject ID
 * @param {string} topicDocumentId - The topic ID
 * @param {string} [subTopicDocumentId] - The subtopic ID (optional)
 * @returns {void}
 */
export function createMissingSyllabusMeta(
  state: OverallSyllabusChecklistSchema,
  subjectDocumentId: string,
  topicDocumentId: string,
  subTopicDocumentId?: string
) {
  // if subject not already selected, create blank meta
  if (!state[subjectDocumentId]) {
    state[subjectDocumentId] = {};
  }
  // if topic not already selected, create blank meta
  if (!state[subjectDocumentId]![topicDocumentId]) {
    state[subjectDocumentId]![topicDocumentId] = { selectedTotal: 0, data: {} };
  }
  // if subtopic not already selected, create blank meta
  if (
    subTopicDocumentId &&
    !state[subjectDocumentId]![topicDocumentId]!.data[subTopicDocumentId]
  ) {
    state[subjectDocumentId]![topicDocumentId]!.data[subTopicDocumentId] = [];
  }
}
